'use strict';

const pushNotification = (posTop, posRight, title, description, type) => {
  const div = document.createElement('div');

  div.className = `notification ${type}`;
  div.style.top = `${posTop}px`;
  div.style.right = `${posRight}px`;

  const titleEL = document.createElement('h2');

  titleEL.className = 'title';
  titleEL.textContent = title;

  const paragraph = document.createElement('p');

  paragraph.textContent = description;

  div.appendChild(titleEL);
  div.appendChild(paragraph);

  document.body.appendChild(div);

  setTimeout(() => {
    div.style.display = 'none';
  }, 2000);
};

pushNotification(
  10,
  10,
  'Title of Success message',
  'Message example.\n ' + 'Notification should contain title and description.',
  'success',
);

pushNotification(
  150,
  10,
  'Title of Error message',
  'Message example.\n ' + 'Notification should contain title and description.',
  'error',
);

pushNotification(
  290,
  10,
  'Title of Warning message',
  'Message example.\n ' + 'Notification should contain title and description.',
  'warning',
);
